export default "__VITE_ASSET__CKbCORlM__"